import { langStore } from "@/stores/lang-store"
import Flex from "@/components/flex"
import Overview from "./_components/overview/overview"
import LeakSeverityView from "./_components/leak-severity/leak-severity-view"
import WeeklyLeakageTrendsView from "./_components/weekly/weekly-leakage-trends-view"
import HalfDoughnutView from "./_components/half-doughnut/half-doughnut-view"
import TableView from "./_components/table/table-view"
import Header from "@/routes/_layout/header"
import OrgLayout from "@/routes/org/org-layout"
import { orgStore } from "@/routes/org/org-store"
import { halfDoughnutStore } from "@/routes/org/_components/half-doughnut/half-doughnut-store"
import { leakSeverityStore } from "@/routes/org/_components/leak-severity/leak-severity-store"
import useIsMobile from "@/hooks/use-is-mobile"

import { useParams } from "react-router-dom"
import Wrapper from "@/components/wrapper"
import { orgName } from "./org-const"

const OrgPage = () => {
  const { org } = useParams()

  const isMobile = useIsMobile()
  const mode = isMobile ? "mobile" : "desktop"
  const HeaderComponent = Header.cubiq[mode]

  const { lang } = langStore()

  const { overview } = orgStore()
  const { yLabels, series } = leakSeverityStore()
  const { doughnuts } = halfDoughnutStore()

  return (
    <OrgLayout header={<HeaderComponent position="sticky" title={orgName[org][lang]} />}>
      <div className="grid grid-cols-1 lg:grid-cols-[750px_1fr] gap-4 lg:gap-6">
        <Flex className={"flex-col min-w-0"}>
          <Flex className="min-h-40 flex-col md:flex-row">
            <Overview overview={overview} />
            <LeakSeverityView series={series} yLabels={yLabels} />
          </Flex>

          <Wrapper.shadow className="w-full flex-1 grid grid-cols-1 sm:grid-cols-2 gap-8 sm:gap-0">
            {doughnuts.map((chart) => (
              <HalfDoughnutView key={chart.id} title={chart.title} chart={chart} />
            ))}
          </Wrapper.shadow>
        </Flex>

        <WeeklyLeakageTrendsView />
      </div>

      <TableView />
    </OrgLayout>
  )
}

export default OrgPage
